<template>
  <h1>Jobs</h1>
  <div v-if="this.stops.length">
    <div v-for ="stop in this.stops" :key="stop.id">
      <p>{{stop.name}}</p>
    </div>
  </div>
  <div v-else>Loading...</div>
</template>

<script>
export default {
    data() {
        return {
            stops: [],
            show: true,
            mtdData:[]
        }
    },
    //https://dev.redsills.com/mtd/nrb_api.php
    //http://localhost:3000/stops
    mounted() {
      console.log('Mounted')
      fetch('https://dev.redsills.com/mtd/nrb_api.php')
        .then(res => res.json())
        //.then(console.log('data in'))
        .then(data => this.stops = data.stops)
        //.then(console.log(this.stops[0].name))
        .catch(err => console.log(err.message))
    }
}
</script>

<style>

</style>